import { PublicKey } from "@solana/web3.js";
import { deserializeUnchecked, serialize } from "borsh";
import { Community } from "./community";
import { Network } from "./network";
import { Categories, HapiAccountType } from "./enums";
export class AddressState {
    constructor(object) {
        Object.assign(this, object);
    }
}
AddressState.schema = new Map([
    [
        AddressState,
        {
            kind: "struct",
            fields: [
                ["account_type", "u8"],
                ["risk", "u8"],
                ["case_id", "u64"],
                ["category", "u8"],
            ],
        },
    ],
]);
AddressState.size = 11;
export class Address {
    constructor(data) {
        /// HAPI account type
        this.accountType = HapiAccountType.Address;
        if (data) {
            Object.assign(this, data);
        }
    }
    static async getAddress(programId, networkAddress, address) {
        return PublicKey.findProgramAddress([Buffer.from("address"), networkAddress.toBuffer(), address.toBuffer()], programId);
    }
    static fromState(state) {
        return new Address({
            accountType: state.account_type,
            risk: state.risk,
            caseId: state.case_id,
            category: Categories[state.category],
        });
    }
    static deserialize(buffer) {
        return Address.fromState(deserializeUnchecked(AddressState.schema, AddressState, buffer));
    }
    static async retrieve(programId, connection, communityName, networkName, address) {
        const [communityAddress] = await Community.getAddress(programId, communityName);
        const [networkAddress] = await Network.getAddress(programId, communityAddress, networkName);
        const [addressAddress] = await Address.getAddress(programId, networkAddress, address);
        const account = await connection.getAccountInfo(addressAddress);
        if (!account) {
            throw new Error(`Address not found: "${address}" in network "${networkName}" (${networkAddress}) in community "${communityName}" (${communityAddress})`);
        }
        return { data: Address.deserialize(account.data), account: addressAddress };
    }
    serialize() {
        const buf = Buffer.alloc(AddressState.size);
        buf.set(serialize(AddressState.schema, this.toState()));
        return buf;
    }
    toState() {
        return new AddressState({
            account_type: this.accountType,
            risk: this.risk,
            case_id: this.caseId,
            category: Categories.indexOf(this.category),
        });
    }
}
//# sourceMappingURL=address.js.map